import { render, staticRenderFns } from "./EditContent.vue?vue&type=template&id=2009d5ee&"
import script from "./EditContent.vue?vue&type=script&lang=js&"
export * from "./EditContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports